import * as actions from "./actions";
import * as autogiroActions from "../autogiro/actions";
import * as sellActions from "../../states/users/portfolioSellOrders/user.sell.order.actions";
import _ from "underscore";
import update from "immutability-helper";
import { INVESTOR_NOTE_GET_SUCCESS } from "../notes/queries";
import {
  USER_GET_INVESTOR_TAGS_REQUEST,
  USER_GET_INVESTOR_TAGS_SUCCESS,
} from "./actions";

let initialState = {
  fetching: false,
  fetched: false,
  fetchError: null,
  currentFilter: "",
  data: null,
  currentUser: null,
  //ToDo this thing below is a new functionality and should replace those two props above
  accountInfos: {},
  adHocDataPending: {},
  adHocDataComplete: {},
  claimSent: false,
  claimSending: false,
  claimSentError: null,
  mandatorError: null,
  mandatorRemoveError: null,
  investorTags: {
    data: null,
    fetching: false,
    fetched: false,
  },
};

const users = (state = initialState, action) => {
  switch (action.type) {
    // GET USERS
    case actions.USERS_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        data: null,
        currentUser: null,
        fetching: true,
        fetchError: null,
      });

    // workaround
    case INVESTOR_NOTE_GET_SUCCESS: {
      return Object.assign({}, state, {
        currentUser: Object.assign({}, state.currentUser, {
          SegmentationTag: action.response.SegmentationTag,
        }),
      });
    }

    case actions.USERS_LIST_GET_SUCCESS: {
      const data = Array.isArray(action.response)
        ? action.response
        : [action.response];
      let selected = data[0];

      if (data.length > 1 && data[1].Domain === "Loanstep") {
        selected = data[1];
      }

      const currentUser =
        data.length > 0 ? Object.assign({}, {}, selected) : null;

      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        data,
        currentUser,
      });
    }
    case actions.USERS_LIST_GET_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        fetchError: action.error,
      });
    case actions.USERS_CHANGE_FILTER:
      return Object.assign({}, state, {
        currentFilter: action.value,
      });
    case actions.SHOW_USER_ACCOUNT: {
      const user = action.domain
        ? _.filter(state.data, (user) => {
            return user.Domain === action.domain;
          })
        : _.filter(state.data, (user) => {
            return user.Id === action.Id;
          });

      return Object.assign({}, state, {
        currentUser: Object.assign({}, state.currentUser, user[0]),
      });
    }

    // Fetching account infos
    case actions.USER_DATA_GET_REQUEST: {
      return Object.assign({}, state, {
        accountInfos: Object.assign({}, state.accountInfos, {
          [action.additionalData]: Object.assign(
            {},
            state.accountInfos[action.additionalData],
            {
              fetching: true,
            },
          ),
        }),
      });
    }

    case actions.USER_DATA_GET_ERROR: {
      return Object.assign({}, state, {
        accountInfos: Object.assign({}, state.accountInfos, {
          [action.additionalData]: Object.assign(
            {},
            state.accountInfos[action.additionalData],
            {
              fetching: false,
              error: action.error,
            },
          ),
        }),
      });
    }

    case actions.USER_DATA_GET_SUCCESS: {
      return update(state, {
        accountInfos: {
          [action.additionalData]: {
            data: { $set: action.response },
            fetching: { $set: false },
            fetched: { $set: true },
            error: { $set: null },
          },
        },
        currentUser:
          state.currentUser && state.currentUser.Id === action.response.Id
            ? { $set: { ...state.currentUser, ...action.response } }
            : { $set: { ...state.currentUser } },
      });
    }

    case actions.USER_ADD_BANK_ACCOUNT_SUCCESS: {
      let data = Object.assign(
        {},
        state.accountInfos[action.additionalData].data,
      );
      let newAccount = {
        Number: action.dataSent.BankNumber,
        IbanIdentifier: action.dataSent.IBANIdentifier,
        SeIdentifier: action.dataSent.SEIdentifier,
        Kind: action.dataSent.Kind,
        HolderName: action.dataSent.HolderName,
        Bic: action.dataSent.Bic,
        Currency: action.dataSent.Currency,
        Id: action.response,
      };
      data.BankAccounts = newAccount;

      let curentUserData = Object.assign({}, state.currentUser);
      curentUserData.BankAccounts.push(newAccount);

      return Object.assign({}, state, {
        accountInfos: Object.assign({}, state.accountInfos, {
          [action.additionalData]: Object.assign(
            {},
            state.accountInfos[action.additionalData],
            {
              data: Object.assign(
                {},
                state.accountInfos[action.additionalData].data,
                data,
              ),
            },
          ),
        }),
        currentUser: curentUserData,
      });
    }

    // Fetching ssn for the above account infos
    case actions.USER_DATA_GET_SSN_REQUEST: {
      return Object.assign({}, state, {
        accountInfos: Object.assign({}, state.accountInfos, {
          [action.additionalData]: Object.assign(
            {},
            state.accountInfos[action.additionalData],
            {
              ssnFetching: true,
            },
          ),
        }),
      });
    }

    case actions.USER_DATA_GET_SSN_ERROR: {
      return Object.assign({}, state, {
        accountInfos: Object.assign({}, state.accountInfos, {
          [action.additionalData]: Object.assign(
            {},
            state.accountInfos[action.additionalData],
            {
              ssnFetching: false,
              error: action.error,
            },
          ),
        }),
      });
    }

    case actions.USER_DATA_GET_SSN_SUCCESS: {
      return Object.assign({}, state, {
        accountInfos: Object.assign({}, state.accountInfos, {
          [action.additionalData]: Object.assign(
            {},
            state.accountInfos[action.additionalData],
            {
              data: Object.assign(
                {},
                state.accountInfos[action.additionalData].data,
                {
                  SSN: action.response,
                },
              ),
              ssnFetching: false,
              ssnfetched: true,
              error: null,
            },
          ),
        }),
      });
    }

    case actions.AD_HOC_USER_PENDING_GET_REQUEST: {
      return Object.assign({}, state, {
        adHocDataPending: Object.assign({}, state.adHocDataPending, {
          [action.additionalData]: Object.assign(
            {},
            state.adHocDataPending[action.additionalData],
            {
              fetching: true,
            },
          ),
        }),
      });
    }

    case actions.AD_HOC_USER_PENDING_GET_SUCCESS: {
      return Object.assign({}, state, {
        adHocDataPending: Object.assign({}, state.adHocDataPending, {
          [action.additionalData]: Object.assign(
            {},
            state.adHocDataPending[action.additionalData],
            {
              data: action.response,
              fetching: false,
              error: action.error,
            },
          ),
        }),
      });
    }

    case actions.AD_HOC_USER_PENDING_GET_ERROR: {
      return Object.assign({}, state, {
        adHocDataPending: Object.assign({}, state.adHocDataPending, {
          [action.additionalData]: Object.assign(
            {},
            state.adHocDataPending[action.additionalData],
            {
              data: Object.assign(
                {},
                state.adHocDataPending[action.additionalData].data,
                action.response,
              ),
              fetching: false,
              fetched: true,
              error: null,
            },
          ),
        }),
      });
    }

    case actions.AD_HOC_USER_GET_REQUEST: {
      return Object.assign({}, state, {
        adHocDataComplete: Object.assign({}, state.adHocDataComplete, {
          [action.additionalData]: Object.assign(
            {},
            state.adHocDataComplete[action.additionalData],
            {
              fetching: true,
            },
          ),
        }),
      });
    }

    case actions.AD_HOC_USER_GET_SUCCESS: {
      return Object.assign({}, state, {
        adHocDataComplete: Object.assign({}, state.adHocDataComplete, {
          [action.additionalData]: Object.assign(
            {},
            state.adHocDataComplete[action.additionalData],
            {
              data: action.response,
              fetching: false,
              error: action.error,
            },
          ),
        }),
      });
    }

    case actions.AD_HOC_USER_GET_ERROR: {
      return Object.assign({}, state, {
        adHocDataComplete: Object.assign({}, state.adHocDataComplete, {
          [action.additionalData]: Object.assign(
            {},
            state.adHocDataComplete[action.additionalData],
            {
              data: Object.assign(
                {},
                state.adHocDataComplete[action.additionalData].data,
                action.response,
              ),
              fetching: false,
              fetched: true,
              error: null,
            },
          ),
        }),
      });
    }

    case autogiroActions.AUTOGIRO_GET_COMPLETED_SUCCESS: {
      let newData = Object.assign({}, state.adHocDataComplete);
      for (let i = 0; i < action.response.length; i++) {
        let payment = action.response[i];
        newData[payment.CreditId] = action.response[i];
      }

      return Object.assign({}, state, {
        adHocDataComplete: Object.assign({}, state.adHocDataComplete, {
          newData,
        }),
      });
    }

    case autogiroActions.AUTOGIRO_GET_PENDING_SUCCESS: {
      let newData = Object.assign({}, state.adHocDataPending);
      for (let i = 0; i < action.response.length; i++) {
        let payment = action.response[i];
        newData[payment.CreditId] = action.response[i];
      }

      return Object.assign({}, state, {
        adHocDataPending: Object.assign({}, state.adHocDataPending, {
          newData,
        }),
      });
    }

    // Claims
    case actions.USER_CUSTOM_CLAIM_SET_REQUEST:
      return Object.assign({}, state, {
        claimSending: true,
        claimSent: false,
        claimSentError: null,
      });
    case actions.USER_CUSTOM_CLAIM_SET_SUCCESS:
      return Object.assign({}, state, {
        claimSending: false,
        claimSent: true,
        claimSentError: null,
      });
    case actions.USER_CUSTOM_CLAIM_SET_ERROR:
      return Object.assign({}, state, {
        claimSending: false,
        claimSent: false,
        claimSentError: action.error,
      });

    // sell orders

    case sellActions.USER_PORTFOLIO_SELL_REQUEST: {
      let creditId = action.additionalData;
      return Object.assign({}, state, {
        mandatorError: null,
        currentUser: Object.assign({}, state.currentUser, {
          sellOrder: Object.assign({}, state.currentUser.sellOrder, {
            [creditId]: {
              sendingSellOrder: true,
              saleorderComplete: false,
              sellOrderError: null,
            },
          }),
        }),
      });
    }

    case sellActions.USER_PORTFOLIO_SELL_SUCCESS: {
      let creditId = action.additionalData;
      return Object.assign({}, state, {
        mandatorError: null,
        currentUser: Object.assign({}, state.currentUser, {
          sellOrder: Object.assign({}, state.currentUser.sellOrder, {
            [creditId]: {
              sendingSellOrder: false,
              saleorderComplete: true,
              sellOrderError: null,
            },
          }),
        }),
      });
    }
    case sellActions.USER_PORTFOLIO_SELL_ERROR: {
      let creditId = action.additionalData;
      return Object.assign({}, state, {
        mandatorError: null,
        currentUser: Object.assign({}, state.currentUser, {
          sellOrder: Object.assign({}, state.currentUser.sellOrder, {
            [creditId]: {
              sendingSellOrder: false,
              saleorderComplete: true,
              sellOrderError: action.error || action.response,
            },
          }),
        }),
      });
    }
    case USER_GET_INVESTOR_TAGS_REQUEST: {
      return Object.assign({}, state, {
        investorTags: Object.assign({}, state.investorTags, {
          fetching: true,
        }),
      });
    }
    case USER_GET_INVESTOR_TAGS_SUCCESS: {
      return Object.assign({}, state, {
        investorTags: Object.assign({}, state.investorTags, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    }

    default:
      return state;
  }
};

export default users;
